import defaut from './default.js'

export const themes = {
    "default" : defaut
}